<div class="delete-dialog-container">

  <div class="delete-icon-wrapper">
    <i class="fa fa-exclamation-triangle"></i>
  </div>

  <h2 class="delete-title">
    Confirmation de suppression
  </h2>

  <p class="delete-message">
    Le rapport automatique <strong>{{ data.rapport.title }}</strong> sera supprimé.
    Cette action est irréversible.
  </p>

  <div class="delete-actions">

    <button
      class="cancel-btn"
      [disabled]="isDeleting"
      (click)="onCancel()">
      Annuler
    </button>

    <button
      class="confirm-btn"
      [disabled]="isDeleting"
      [class.is-loading]="isDeleting"
      (click)="onConfirm()">

      <span class="spinner" *ngIf="isDeleting"></span>

      <span>{{ isDeleting ? 'Suppression...' : 'Confirmer' }}</span>
    </button>

  </div>

</div>